<template>
    <m-dialog :heading="title" :show="show" @update:show="e => $emit('update:show', e)" width="800px">
        <div class="table items-center bg-white border rounded my-1 w-full">
            <div class="table-cell w-1 align-middle">
                <div class="sprite-icons-search bg-white"></div>
            </div>
            <div class="table-cell align-middle">
                <input class="text-lg p-2 w-full outline-none bg-white" v-model="text" @keydown.enter="search()"
                       v-focus="v-focus"/>
            </div>
            <div class="table-cell w-1 align-middle">
                <div class="btn btn-primary" @click="search()">Search</div>
            </div>
        </div>
        <span v-if="!initial"> </span>
        <m-pagedtable url="/deeds/lookup" :args="args" @click="itemClick" v-else-if="type == 0">
            <template slot="header">
                <th>Township</th>
                <th>Province</th>
                <th>Local Authority</th>
                <th>First Unit</th>
                <th>Last Unit</th>
                <th>No. Units</th>
                <th>Deeds Office</th>
            </template>
            <template v-slot="{row}">
                <td>{{ row.name }}</td>
                <td>{{ row.province | province }}</td>
                <td>{{ row.localAuthority }}</td>
                <td>{{ row.first }}</td>
                <td>{{ row.last }}</td>
                <td>{{ row.count }}</td>
                <td>{{ row.deedOffice | deedOffice }}</td>
            </template>
        </m-pagedtable>
        <m-pagedtable url="/deeds/lookup" :args="args" @click="itemClick" v-else-if="type == 1">
            <template slot="header">
                <th>Farm Name</th>
                <th>Farm Number</th>
                <th>Division</th>
                <th>Province</th>
                <th>Local Authority</th>
                <th>First Unit</th>
                <th>Last Unit</th>
                <th>No. Units</th>
                <th>Deeds Office</th>
            </template>
            <template v-slot="{row}">
                <td>{{ row.name }}</td>
                <td>{{ row.number }}</td>
                <td>{{ row.registrationDivision }}</td>
                <td>{{ row.province | province }}</td>
                <td>{{ row.localAuthority }}</td>
                <td>{{ row.first }}</td>
                <td>{{ row.last }}</td>
                <td>{{ row.count }}</td>
                <td>{{ row.deedOffice | deedOffice }}</td>
            </template>
        </m-pagedtable>
        <m-pagedtable url="/deeds/lookup" :args="args" @click="itemClick" v-else-if="type == 2">
            <template slot="header">
                <th>Name</th>
                <th>Number</th>
                <th>Province</th>
                <th>Local Authority</th>
                <th>First Unit</th>
                <th>Last Unit</th>
                <th>No. Units</th>
                <th>Deeds Office</th>
            </template>
            <template v-slot="{row}">
                <td>{{ row.name }}</td>
                <td>{{ row.number }}</td>
                <td>{{ row.province | province }}</td>
                <td>{{ row.localAuthority }}</td>
                <td>{{ row.first }}</td>
                <td>{{ row.last }}</td>
                <td>{{ row.count }}</td>
                <td>{{ row.deedOffice | deedOffice }}</td>
            </template>
        </m-pagedtable>
        <m-pagedtable url="/deeds/lookup" :args="args" @click="itemClick" v-else-if="type == 3">
            <template slot="header">
                <th>Scheme Name</th>
                <th>Scheme Number</th>
                <th>Develop Year</th>
                <th>Local Authority</th>
                <th>First Unit</th>
                <th>Last Unit</th>
                <th>No. Units</th>
                <th>Deeds Office</th>
            </template>
            <template v-slot="{row}">
                <td>{{ row.name }}</td>
                <td>{{ row.number }}</td>
                <td>{{ row.developYear }}</td>
                <td>{{ row.localAuthority }}</td>
                <td>{{ row.first }}</td>
                <td>{{ row.last }}</td>
                <td>{{ row.count }}</td>
                <td>{{ row.deedOffice | deedOffice }}</td>
            </template>
        </m-pagedtable>
    </m-dialog>
</template>

<script>
import {types} from '@/components/fielddefs.js'

function getName(type) {
    return ['Township', 'Farm', 'Agricultural Holding', 'Scheme'][type]
}

export default {
    props: {
        show: Boolean,
        office: [String, Number],
        type: Number
    },
    data() {
        return {
            initial: false,
            text: '',
            filter: ''
        }
    },
    watch: {
        show(v) {
            if (v) {
                this.initial = false
                this.filter = ''
                this.text = ''
            }
        }
    },
    methods: {
        search() {
            this.initial = true
            this.filter = this.text
        },
        itemClick(row) {
            this.$emit('update:show', false)
            this.$emit('select', row)
        }
    },
    computed: {
        title() {
            const name = getName(this.type);
            if (!this.office) {
                return `${name} Lookup`
            }
            if (typeof this.office === 'string')
                return `${name} Lookup in ${this.office}`;

            return `${name} Lookup in ${types.deedsOffice[this.office]}`;
        },
        args() {
            return {
                search: this.filter,
                office: this.office,
                type: this.type
                // Township = 0,
                // Farm = 1,
                // Scheme = 2,
                // AgriculturalHolding = 3
            }
        }
    }
}
</script>
